<section class="channel-message">
    <div>
        <div class="hash"></div>
        <h3 (click)="openDialogChannel()">{{ channel.name }}</h3>
    </div>
    <span> @if (channel.ownerID) {<a (click)="openShowUserDialog(channel.ownerID)">{{ dataService.getUserNameById(channel.ownerID) }}</a> hat diesen Channel erstellt. }
        Das ist der Anfang des Channels</span>
</section>
